import AdvancedAnalyticsRoutes from './advanced-analytics';
import CommonRouters from './common';
import CostsRoutes from './costs';
import CrmRoutes from './crm';
import DevicesPage from './devices';
import DriverBehaviorRoutes from './driver-behavior';
import DriverRoutes from './drivers';
import FuelCardRoutes from './fuel-card';
import HomeRoutes from './home';
import InsuranceRoutes from './insurance';
import IntegrationsRoutes from './integrations';
import MonitoringRoutes from './monitoring';
import OnboardingRoutes from './onboarding';
import ProductivityRoutes from './productivity';
import ReportsRoutes from './reports';
import RoutingRoutes from './routing';
import SafetyRankingRoutes from './safety-ranking';
import SettingsRoutes from './settings';
import SpeedingRoutes from './speeding';
import TrackingRoutes from './tracking';
import VehicleGroupsRoutes from './vehicle-groups';
import VehicleRoutes from './vehicles';

import type { Location } from '@cobliteam/common-types';

import BusinessManagerRoutes from '@cobliteam/business-manager/src/routes';
import ChecklistsRoutes from '@cobliteam/checklists/src/routes';
import MaintenanceRoutes from '@cobliteam/maintenance/src/routes';
import MediaRoutes from '@cobliteam/media/src/routes';
import ProofOfConclusionRoutes from '@cobliteam/proof-of-conclusion/src/routes';
import NewReportsRoutes from '@cobliteam/reports/src/routes';
import TriggersRoutes from '@cobliteam/triggers/src/routes';

export interface IRoute {
  path: Location;
  title?: string;
  featureFlag?: string;
  component?: React.LazyExoticComponent<React.ComponentType<any>>;
  render?: (props: any) => React.ReactNode;
  routes?: IRoute[];
  accessDeniedDescription?: string;
  exact?: boolean;
}

const routes = [
  ...AdvancedAnalyticsRoutes,
  ...ChecklistsRoutes,
  ...CostsRoutes,
  ...DevicesPage,
  ...DriverBehaviorRoutes,
  ...SafetyRankingRoutes,
  ...DriverRoutes,
  ...FuelCardRoutes,
  ...HomeRoutes,
  ...InsuranceRoutes,
  ...IntegrationsRoutes,
  ...MaintenanceRoutes,
  ...MediaRoutes,
  ...MonitoringRoutes,
  ...ProductivityRoutes,
  ...ReportsRoutes,
  ...NewReportsRoutes,
  ...RoutingRoutes,
  ...SettingsRoutes,
  ...SpeedingRoutes,
  ...TrackingRoutes,
  ...VehicleRoutes,
  ...VehicleGroupsRoutes,
  ...CommonRouters,
  ...TriggersRoutes,
  ...OnboardingRoutes,
  ...ProofOfConclusionRoutes,
  ...CrmRoutes,
  ...BusinessManagerRoutes,
];

export default routes;
